import { siteData } from "../../data/siteData";
import "./Testimonials.css";

export default function Testimonials() {
  return (
    <section className="testimonials">
      <div className="container">
        <div className="testimonials__head">
          <div>
            <span className="eyebrow">Testimoni</span>
            <h2 className="testimonials__title">Kisah Bahagia Klien Kami</h2>
          </div>
          <a href="#" className="btn btn-outline-green">Baca Semua</a>
        </div>

        <div className="testimonials__grid">
          {siteData.testimonials.map((t, i) => (
            <div key={i} className={`testi${i === 0 ? ' testi--dark' : ''}`}>
              <div className="testi__stars">★★★★★</div>
              <p className="testi__text">"{t.text}"</p>
              <div className="testi__author">
                <div className="testi__avatar">{t.name.charAt(0)}</div>
                <div>
                  <div className="testi__name">{t.name}</div>
                  <div className="testi__role">{t.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
